import { render, staticRenderFns } from "./index.vue?vue&type=template&id=53aa8f44&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=53aa8f44&prod&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=53aa8f44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aa8f44",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CheckoutCarriers: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Checkout/Carriers/index.vue').default})
